import React, { useState, useEffect } from "react";
import MainView from "../../../components/MainView";

import './styles.css';

import billServices from "../../../services/academy/academyBillServices";
import compare from "../../../functions/compare";

import NavHistory from '../../../components/NavHistory';
import BillsCard from './BillsCard';
import PopupBill from "./PopupBill";
import PopupNewBill from "./PopupNewBill";

export default function BillsPage(props) {
    const [popupBillVisible, setPopupBillVisible] = useState(false);
    const [popupBillData, setPopupBillData] = useState({});
    const [popupNewBillVisible, setPopupNewBillVisible] = useState(false);
    const [popupNewBillData, setPopupNewBillData] = useState({});
    const [popupNewBillType, setPopupNewBillType] = useState(false);
    const [bills, setBills] = useState(null);

    useEffect(() => {
        readBills();
    }, []);

    async function readBills() {
        const response = await billServices.getBills();
        if (response.status === 200) {
            setBills(response.data);
        } else
            alert("Erro ao ler contas, tente novamente!");
    }

    function updateBill(bill) {
        let index = bills.findIndex(item => item.id === bill.id);
        if (index !== -1) {
            let auxArray = bills.slice();
            auxArray[index] = bill;
            setBills(auxArray);
        }

        if (popupBillData.id && popupBillData.id === bill.id) setPopupBillData(bill);
    }

    function onItemClick(bill) {
        setPopupBillData(bill);
        setPopupBillVisible(true);
    }

    function onButtonClick(type = null) {
        setPopupNewBillType(type);
        setPopupNewBillData({});
        setPopupNewBillVisible(true);
    }

    function editBill(bill) {
        setPopupNewBillData(bill);
        setPopupNewBillVisible(true);
    }

    return (
        <MainView currentPage='bills'>
            <NavHistory navPages={['Contas']} />

            <div className='bills-page-cards'>
                <div className='bills-page-cards-group'>
                    <BillsCard
                        toPay
                        bills={bills}
                        onItemClick={onItemClick}
                        onButtonClick={onButtonClick}
                    />
                </div>

                <div className='bills-page-cards-group'>
                    <BillsCard
                        toReceive
                        bills={bills}
                        onItemClick={onItemClick}
                        onButtonClick={onButtonClick}
                    />
                </div>
            </div>

            <PopupBill
                visibility={popupBillVisible}
                setVisibility={setPopupBillVisible}
                data={popupBillData}
                editBill={editBill}
                onEdit={updateBill}
            />

            <PopupNewBill
                visibility={popupNewBillVisible}
                setVisibility={setPopupNewBillVisible}
                type={popupNewBillType}
                data={popupNewBillData}
                onCreate={readBills}
                onUpdate={updateBill}
            />
        </MainView>
    )
}